import React from "react";
import Blocks from "editorjs-blocks-react-renderer";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Button from "../button";
import ImageRenderer from "../imageRenderer";

const PhotoTitleText = ({ data }) => {
  if (!data) {
    return null;
  }
  const image = getImage(data.Photo.localFile);
  return (
    <section className="PhotoTitleText p-5 ">
      <div className="mx-auto max-w-screen-xl xxl:max-w-screen-3xl bg-white shadow-xl rounded-xl  lg:my-18 my-12">
        <div className="flex flex-col lg:flex-row h-full  items-stretch gap-8">
          <div className=" w-full">
            <GatsbyImage
              image={image}
              alt="image"
              className="w-full h-full lg:rounded-l-lg lg:rounded-r-none	rounded-t-lg"
            />
          </div>
          <div className="w-full p-5">
            <h2 className="text-5xl font-bold ">{data.TitleH2}</h2>
            {data?.Text?.data?.Text ? (
              <div className="prose">
                <Blocks
                  data={JSON.parse(data.Text.data.Text)}
                  renderers={{
                    image: ImageRenderer,
                  }}
                />
                <div className="mt-3">
                  {data.Button?.ShowButton && <Button data={data.Button} />}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhotoTitleText;
